export default __webpack_public_path__ + "static/media/More-category.fd01bf45.png";